import { BarceloComponent } from "components-utils";

const AllContainers = {
  submenuContainer: BarceloComponent({
    selector: ".c-submenu-container",
    path: "barcelo/containers/submenu-container/js/submenu-container",
  }),

  container: BarceloComponent({
    selector: ".c-container",
    path: "barcelo/containers/generic-container/js/c-container",
  }),

  swiper: BarceloComponent({
    selector: ".c-swiper",
    path: "barcelo/containers/swiper/js/c-swiper",
  }),

  accordion: BarceloComponent({
    selector: ".accordion-item, .c-megamenu",
    path: "barcelo/containers/accordion-item/js/c-accordion",
  }),

  tabsdropdown: BarceloComponent({
    selector: ".c-tabsdropdown",
    path: "barcelo/containers/dropdown/js/c-dropdown",
  }),

  tabMenu: BarceloComponent({
    selector: ".c-tab-menu",
    path: "barcelo/containers/tab-menu/tab-menu/js/c-tab-menu",
  }),

  launchersContainer: BarceloComponent({
    selector: ".launchers-container",
    path: "barcelo/containers/launchers-container/js/launchers-container",
  }),

  xfContainer: BarceloComponent({
    selector: ".c-xf-container",
    path: "barcelo/containers/xf-container/js/x-xf-container",
    enableObserver: true,
  }),

  marketTargeting: BarceloComponent({
    selector: ".c-market-targeting-dl-id",
    path: "barcelo/containers/market-targeting/js/c-market-targeting",
  }),

  languageTargeting: BarceloComponent({
    selector: ".c-language-targeting-dl-id",
    path: "barcelo/containers/language-targeting/js/c-language-targeting",
  }),
};

export default AllContainers;
